module.exports = __webpack_public_path__ + "static/img/independent2.d99c750.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/independent2.png
// module id = RGzO
// module chunks = 1